import React, { useEffect, useState } from 'react'
import { GuardarPresupuestoAsignado, InformacionGeneralPresupuestoGPE } from './TypesPresupuestoGPEHE'
import { GuardarPresupuestoUnidad, ObtenerInformacionUnidadesGPE } from './FunctionsAsignacionPresupuesto'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import Cargando from 'components/Varios/Cargando'
import TablaUnidadesGPEPresupuestoHE from './TablaUnidadesGPEPresupuestoHE'
import { ChangeToPromise } from 'functions/GeneralFunctions'
import { Row, Col } from "reactstrap"
import CardRegimenHE from 'components/Admin/Horas Extras/Proyeccion Horas Extras/CardRegimenHE'
import ModalCargando from 'components/Varios/ModalCargando'
import { Tab, Tabs } from 'react-bootstrap'


export default function ModificacionPresupuestoGPE() {

    const [informacionGeneralUnidadesGPE, setinformacionGeneralUnidadesGPE] = useState<InformacionGeneralPresupuestoGPE | undefined>(undefined)
    const [loading, setloading] = useState<boolean>(false)

    const TITULO_PANTALLA = "MODIFICACION PRESUPUESTARIA DE HORAS EXTRAS PARA EL AÑO " + (informacionGeneralUnidadesGPE ? informacionGeneralUnidadesGPE.anioPresupuesto.toString() : "")


    async function ObtenerInformacionGeneral() {
        setloading(true)

        const respuesta = await ObtenerInformacionUnidadesGPE(true);

        if (respuesta.status === 200 && respuesta.dataResponse) {
            setinformacionGeneralUnidadesGPE(respuesta.dataResponse)

        }
        else if (respuesta.status === 401) {
            const messageDefault = "No es un usuario autorizado"
            showAlert(messageDefault, false)
        }
        else {
            const messageDefault = "No ha sido posible obtener información de las unidades enviadas a GPE"
            showAlert(respuesta.errorMessage ?? messageDefault, false)
        }


        setloading(false)
    }


    useEffect(() => {
        ObtenerInformacionGeneral();
    }, [])


    const contenidoCardRegimen = (
        <Row className="row-no-margin">
            {informacionGeneralUnidadesGPE && informacionGeneralUnidadesGPE.totalProyeccionUnidades && informacionGeneralUnidadesGPE.totalProyeccionUnidades.valorTotalizadoRegimen.map((regimen, index) => (
                <Col lg={6} xl={4} key={index} className="mb-3">
                    <CardRegimenHE
                        index={index}
                        regimenLaboralProyectado={regimen}
                        totalProyeccionUnidades={informacionGeneralUnidadesGPE.totalProyeccionUnidades}
                    />
                </Col>
            ))}
        </Row>
    )


    if (loading) {
        return (
            <div className='content'>
                <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>

                <Cargando
                />
            </div>
        )
    }

    return (
        <div className='content'>
            <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>
            {
                informacionGeneralUnidadesGPE &&
                <React.Fragment>
                    {/* {contenidoCardRegimen} */}

                    {loading && <Cargando />}

                    {!loading &&
                        <TablaUnidadesGPEPresupuestoHE
                            idPeriodoProyeccion={informacionGeneralUnidadesGPE.idPeriodoProyeccion}
                            anioInformacionProyeccion={informacionGeneralUnidadesGPE.anioPresupuesto}
                            regimendisponible={informacionGeneralUnidadesGPE.listadoRegimenLaboral}
                            selectedUnidades={informacionGeneralUnidadesGPE.informacionUnidades}
                            totalProyeccion={informacionGeneralUnidadesGPE.totalProyeccionUnidades}
                            tipo={"MODIFICACION"}
                            //onGuardarInformacion={(unidades) => AsignarPresupuestos(unidades)}
                            onActualizarTabla={() => ObtenerInformacionGeneral()}
                            parametros={informacionGeneralUnidadesGPE.parametros}
                            tipoEncargoUnidad={informacionGeneralUnidadesGPE.encargoPersonaConsulta}
                            defaultRowNumber={50}
                            fechaActual= {new Date().toString()}
                        />
                    }
                </React.Fragment>
            }

        </div>
    )
}
